import {AdapterProps, FieldAdapter} from '../field-factory';
import {Rating as MantineRating, RatingProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $RatingAdapterProps = AdapterProps<RatingProps>;

export const $RatingAdapter: FC<FieldAdapter<$RatingAdapterProps>> = ({
  inputProps: {onChange, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
  } = control;

  const {readOnly} = useContext(ReadOnlyContext);

  const _onChange: RatingProps['onChange'] = (value) => {
    if (readOnly) return;
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantineRating
      readOnly={readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};